import { Grid, makeStyles, Typography } from "@material-ui/core";
import { COLORS } from "../../../../theme/colors";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(4),
  },
  col: {
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  separateContainer: {
    position: "relative",
    height: "100%",
  },
  separate: {
    position: "absolute",
    width: 1,
    height: "250px",
    bottom: "20px",
    left: "-10px",
    borderRight: `1px dashed ${COLORS.darks[0][50]}`
  },
}));

export const XAxis = ({ labels }) => {
  const classes = useStyles();

  return (
    <Grid className={classes.root} container justifyContent="space-evenly">
      <Grid className={classes.col} item xs={4}>
        <Typography variant="body2" align="center">
          {labels[0]}
        </Typography>
      </Grid>
      <Grid className={classes.col} item xs={4}>
        <Grid className={classes.separateContainer} container>
          <div className={classes.separate} />
          <Typography variant="body2" align="center">
            {labels[1]}
          </Typography>
        </Grid>
      </Grid>
      <Grid className={classes.col} item xs={4}>
        <Typography variant="body2" align="center">
          {labels[2]}
        </Typography>
      </Grid>
    </Grid>
  );
};
